module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/linkalias/linkalias.component.css
// module id = ./src/app/admin/linkalias/linkalias.component.css
// module chunks = main